var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcWrite = function SvgIcWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_write_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.093 4.382-1.29-1.29c-.2-.199-.523-.199-.723 0L7.862 4.31l2.013 2.013 1.218-1.218c.2-.2.2-.523 0-.723ZM2.626 9.547l4.308-4.309 2.013 2.013-4.308 4.308a.512.512 0 0 1-.345.15l-1.878.06.06-1.877a.511.511 0 0 1 .15-.345Zm8.105-7.382a1.824 1.824 0 0 0-2.58 0L1.699 8.619a1.824 1.824 0 0 0-.533 1.23l-.075 2.305a.912.912 0 0 0 .941.941l2.305-.074c.088-.003.175-.012.26-.028h8.269a.656.656 0 1 0 0-1.312H6.373l5.648-5.648a1.824 1.824 0 0 0 0-2.579l-1.29-1.29Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_write_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgIcWrite;